class MusiqueModel{
    constructor(titre,interprete,annee,video){
        this.titre = titre;
        this.interprete = interprete;
        this.annee = annee;
        this.video = video;
    }

    static fromJSON(json){
        return new MusiqueModel(json.titre, json.interprete, json.annee, json.video);
    }
}

export default MusiqueModel;